module.exports = __webpack_public_path__ + "img/erp03.b4787aa4.jpg";